/* ===================================================
   Méga Menu Zoomalin — assets/mega-menu.js
   v3 — Masquage auto du header natif via JS
   =================================================== */

(function () {
  'use strict';

  const DESKTOP_BREAKPOINT = 990;
  const isMobile = () => window.innerWidth < DESKTOP_BREAKPOINT;

  // Au chargement : on initialise selon le viewport
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    handleHeaderVisibility();
    if (!isMobile()) initMegaMenu();

    // Au resize, on bascule entre les deux modes
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        handleHeaderVisibility();
        if (!isMobile() && !window.__megaMenuInitialized) initMegaMenu();
      }, 150);
    });
  }

  /* ====================================================
     Masque (desktop) ou restaure (mobile) le header natif
     ==================================================== */
  function handleHeaderVisibility() {
    const wrapper = document.querySelector('[data-mega-menu]');
    if (!wrapper) return;

    // Vérifie si l'option de masquage est activée
    const hideNative = wrapper.getAttribute('data-hide-native') === 'true';
    if (!hideNative) return;

    const ourSection = wrapper.closest('.shopify-section');
    if (!ourSection) return;

    if (isMobile()) {
      // En mobile : on restaure les sections précédentes
      restoreSiblings(ourSection);
    } else {
      // En desktop : on masque toutes les sections qui précèdent
      hidePreviousSiblings(ourSection);
    }
  }

  function hidePreviousSiblings(targetSection) {
    let prev = targetSection.previousElementSibling;
    while (prev) {
      // On masque si c'est une shopify-section ou un élément contenant le header natif
      if (prev.classList.contains('shopify-section') ||
          prev.tagName.toLowerCase() === 'section' ||
          prev.tagName.toLowerCase() === 'header' ||
          prev.querySelector('header, .header, .site-header, .announcement, [class*="header"]')) {
        prev.dataset.megaMenuHidden = 'true';
        prev.style.setProperty('display', 'none', 'important');
      }
      prev = prev.previousElementSibling;
    }

    // Cas où le header natif serait dans un container parent (section group wrapper)
    const parent = targetSection.parentElement;
    if (parent && parent !== document.body) {
      // On parcourt aussi les frères du parent (au cas où le wrapper séparerait les sections)
      let prevParent = parent.previousElementSibling;
      while (prevParent) {
        if (prevParent.classList.contains('shopify-section') ||
            prevParent.tagName.toLowerCase() === 'header' ||
            prevParent.querySelector('header, .header, .site-header')) {
          prevParent.dataset.megaMenuHidden = 'true';
          prevParent.style.setProperty('display', 'none', 'important');
        }
        prevParent = prevParent.previousElementSibling;
      }
    }
  }

  function restoreSiblings() {
    document.querySelectorAll('[data-mega-menu-hidden="true"]').forEach(el => {
      el.style.removeProperty('display');
      delete el.dataset.megaMenuHidden;
    });
  }

  /* ====================================================
     Initialisation du méga menu (desktop uniquement)
     ==================================================== */
  function initMegaMenu() {
    if (window.__megaMenuInitialized) return;
    window.__megaMenuInitialized = true;

    const wrapper = document.querySelector('[data-mega-menu]');
    if (!wrapper) return;

    const navLinks = wrapper.querySelectorAll('.mega-nav-link.has-mega');
    const panels = wrapper.querySelectorAll('.mega-menu-panel');
    let closeTimer = null;

    function closeAll() {
      panels.forEach(p => {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      navLinks.forEach(l => {
        l.classList.remove('is-open');
        l.setAttribute('aria-expanded', 'false');
      });
    }

    function openPanel(panelId, link) {
      clearTimeout(closeTimer);
      closeAll();
      const panel = wrapper.querySelector(`[data-panel="${panelId}"]`);
      if (panel) {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        link.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
    }

    function scheduleClose() {
      closeTimer = setTimeout(closeAll, 150);
    }

    navLinks.forEach(link => {
      const menuId = link.getAttribute('data-menu');
      link.addEventListener('mouseenter', () => openPanel(menuId, link));
      link.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (link.classList.contains('is-open')) closeAll();
          else openPanel(menuId, link);
        }
        if (e.key === 'Escape') closeAll();
      });
    });

    panels.forEach(panel => {
      panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      panel.addEventListener('mouseleave', scheduleClose);
    });

    const nav = wrapper.querySelector('.mega-nav');
    if (nav) nav.addEventListener('mouseleave', scheduleClose);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeAll();
    });

    document.addEventListener('cart:updated', e => {
      const count = wrapper.querySelector('[data-cart-count]');
      if (count && e.detail && typeof e.detail.cart === 'object') {
        count.textContent = e.detail.cart.item_count;
      }
    });
  }
})();